import { organizationReducerKey } from './OrganizationConstants';

export const organization = (state) => state.get(organizationReducerKey);

export const isLoading = (state) => organization(state).get('isLoading');
